import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Table,
  TableContainer,
  TableCell,
  TableBody,
  Paper,
  TableRow,
} from "@mui/material";
import basestyle from "../../CSS/Base.module.css";
import assetsIcon from '../../../assets/images/Group_21.png'
import { getCapitalSummaryByPId } from "../services/Summary/accountSummaryService";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { formatCurrency } from "../Utils/formatUtils";
import * as constants from "../../../constants";
import TableRowSummaryDesign from "./SummaryTableRowDesign";
import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';

function Capital() {
  const userInfo = useSelector((state: RootState) => state.auth);
  const [glNonAssets, setGLNonAssets] = useState<any>([]);
  const [glNonTotalBanalance, setGLNonTotoalBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const translate = t as (key: string) => string;

  useEffect(() => {
    getCaptialByPid(userInfo.defaultParticipantId, userInfo.clientId);
  }, [userInfo?.defaultParticipantId]);

  async function getCaptialByPid(pId: number, clientId: number) {
    try {
      setLoading(true);
      const resLoanByPid = await getCapitalSummaryByPId(pId, clientId);
      if (resLoanByPid.status === constants.STATUS_CODES.SUCCESS) {
        const originalData = resLoanByPid.data.data.glNonAssets; 
        const swappedData = originalData.map((item: any) => {
          if (item.glAcctName === constants.ACCOUNT_SUMMARY_NAME.EQUITY_NAME) {
            return { ...item, glAcctName: constants.ACCOUNT_SUMMARY_NAME.REVENUE_NAME };
          }
          if (item.glAcctName === constants.ACCOUNT_SUMMARY_NAME.REVENUE_NAME) {
            return { ...item, glAcctName: constants.ACCOUNT_SUMMARY_NAME.EQUITY_NAME };
          }
          return item;
        }); 
        setGLNonAssets(swappedData);
        setGLNonTotoalBalance(resLoanByPid.data.data.totalBalance);
      }
    } catch (error) {
      console.error(translate("errorHandlingFundSource"), error);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Paper sx={{ display: "flex", backgroundColor: "transparent", boxShadow: "none", borderRadius: "18px" }}>
        <Box className={`${basestyle.assetsContainer}`}>
          <Box className={`${basestyle.circleWhite}`}>
            <img src={assetsIcon} alt="Capital Logo" className="LabilitiesLogo" style={{ width: "80px", height: "auto" }} />
          </Box>
          <Typography variant="h5" className={`${basestyle.assetsText}`}>
            {translate('capital')}
          </Typography>
        </Box>
        {loading ? (
          <Box className="loadingContainer">
            <CircularProgress size={20} />
            <Typography variant="body2" sx={{ marginLeft: 1 }}>
              Loading...
            </Typography>
          </Box>
        ) : (
          <TableContainer className={basestyle.mainTableContainer}>
            <Table size="small" sx={{ borderCollapse: "collapse" }}>
              <TableBody>
                {(
                  glNonAssets.map((item:any, index: React.Key | null | undefined) => (
                    <TableRowSummaryDesign key={index} variant={"changeOddtoEven"}>
                      <TableCell
                        sx={{ border: "none" }}
                        className={`${basestyle.tableCellStyle}`}
                      >
                        <Typography  sx={{ color: "black" }} >
                          {item.glAcctName}
                        </Typography>
                      </TableCell>
                      <TableCell
                        align="right"
                        className={`${basestyle.amountText} ${basestyle.tableCellStyle}`}
                        sx={{ border: "none" }}
                      >
                        {formatCurrency(item.glAcctBalance)}
                      </TableCell>
                    </TableRowSummaryDesign>
                  ))
                )}
                {/* Total Available Balance Row */}

              </TableBody>
            </Table>
            {!loading && <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                border: "1px solid #ddd",
                backgroundColor: "#f9f9f9", // Light background for better visibility
                height: "36px"
              }}
              className={`${basestyle.totalAmountStyle}`}
            >
              <Box
                sx={{
                  display: "flex",
                alignItems: "center",
                }}
              >
                <Typography
                  sx={{ border: "none", textAlign: "right", display: "flex", alignItems: "center" }}
                >
                  <span className={basestyle.labelBoldText}>{translate("totalAvailableBalance")}</span>
                      &nbsp;
                </Typography>

                <span
                  className={`${basestyle.amountTotalAvaliable}`}
                  style={{display: "inline-block", fontWeight:"bold",
                paddingRight:"16px"  }}
                >
                  {formatCurrency(glNonTotalBanalance)}
                </span>
              </Box>
            </Box>
            }
          </TableContainer>
        )}
      </Paper>

    </>

  );
}
export default Capital;
